import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { SymptomMatrix } from './components/SymptomMatrix';
import { Method } from './components/Method';
import { ProductStack } from './components/ProductStack';
import { Testimonials } from './components/Testimonials';
import { PricingClose } from './components/PricingClose';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <SymptomMatrix data-id="element-4" />
        <Method data-id="element-5" />
        <ProductStack data-id="element-6" />
        <Testimonials data-id="element-7" />
        <PricingClose data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}